import {
	AppBar,
	Dialog,
	IconButton,
	Toolbar,
	WithStyles,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import grey from '@material-ui/core/colors/grey';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { UpwardTransition } from 'src/utils';

import * as Stickyfill from 'stickyfilljs';
import {
	ISubCareerInfo,
	setCurriculumAchieveCondition,
	setCurriculumDetailDialog,
} from '../actions/search';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ScenarioFactory from '../scenario/SearchScenarioFactory';
import { CMItemCode, isValid } from '../utils/CMData';
import { isMobile } from '../utils/MobileCheck';
import { Routes, Screens } from '../utils/Routes';
import CareerDetail from './CareerDetail';
import SkillDetail from './SkillDetail';

const styles = (theme: Theme) =>
	createStyles({
		accessBar: {
			backgroundColor: '#e8eaf6',
			marginTop: theme.spacing(1),
			position: 'sticky',
			top: '0px',
			zIndex: 99,
		},
		appBar: {
			position: 'relative',
			width: 'auto',
		},
		button: {
			margin: '10px',
			wordBreak: 'keep-all',
		},
		careerDialog: {
			width: '80%',
		},
		cellItemName: {
			backgroundColor: grey[300],
			minWidth: '150px',
			textAlign: 'right',
			width: '20%',
		},
		cellItemValue: {
			textAlign: 'left',
			width: '80%',
		},
		flex: {
			flex: 1,
		},
		headerName1: {
			backgroundColor: grey[300],
			width: '10%',
		},
		headerName2: {
			backgroundColor: grey[300],
			width: '50%',
		},
		headerName3: {
			backgroundColor: grey[300],
			width: '15%',
		},
		headerName4: {
			backgroundColor: grey[300],
			width: '10%',
		},
		headerName5: {
			backgroundColor: grey[300],
			width: '8%',
		},
		headerName6: {
			backgroundColor: grey[300],
			width: '7%',
		},
		link: {
			color: 'blue',
			cursor: 'pointer',
		},
		mobileCellItemName: {
			alignItems: 'center',
			backgroundColor: grey[300],
			display: 'flex',
			minHeight: '40px',
			minWidth: '10px',
			paddingLeft: '5px',
			textAlign: 'left',
			whiteSpace: 'normal',
			width: '100%',
			wordBreak: 'break-all',
		},
		mobileCellItemValue: {
			alignItems: 'center',
			display: 'flex',
			minHeight: '40px',
			paddingLeft: '5px',
			textAlign: 'left',
			whiteSpace: 'normal',
			width: '100%',
			wordBreak: 'break-all',
		},
		mobileFlex: {
			flex: 1,
			fontSize: '16px',
			marginTop: '10px',
		},
		mobileTable: {
			minWidth: '100px',
		},
		root: {
			flexGrow: 1,
			padding: 18,
		},
		scrollPaper: {
			alignItems: 'flex-start',
		},
		topCellItemName: {
			minWidth: '150px',
			textAlign: 'right',
		},
		topCellItemValue: {
			minWidth: '200px',
			textAlign: 'left',
		},
		topTable: {
			display: 'inline',
			minWidth: '300px',
			width: '50%',
		},
		wrapDiv: {
			margin: '10px',
		},
	});

interface IRouteParams {
	curriculum_id: string;
}

// tslint:disable-next-line: no-empty-interface
interface IRouteState {}

interface IState {
	openCareerDetailDialog: boolean;
	openSkillDetailDialog: boolean;
	careerID: string;
}

/**
 * カリキュラム達成条件
 */
class CurriculumAchieveCondition extends React.Component<IProps, IState> {
	protected rootDiv: HTMLElement | null;

	public constructor(props: IProps) {
		super(props);
		this.state = {
			careerID: '',
			openCareerDetailDialog: false,
			openSkillDetailDialog: false,
		};
		if (this.props.curriculumId) {
			this.props.fetchCurriculumAchieveCondition(
				this.props.curriculumId,
				this.props.token
			);
		}
		this.showCareerDetail = this.showCareerDetail.bind(this);
		this.showCurriculumDetail = this.showCurriculumDetail.bind(this);
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		window.scrollTo({
			top: 0,
		});
		if (!this.props.match || !this.props.match.params) {
			return;
		}

		const curriculumId = this.props.match.params.curriculum_id;

		// データ取得処理
		this.props.fetchCurriculumAchieveCondition(
			curriculumId,
			this.props.token
		);
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		// データを破棄
		this.props.resetCurriculumAchieveCondition();
	}

	public render() {
		const {
			classes,
			curriculumInfo,
			requiredCareers,
			optionalCareers,
		} = this.props;
		const cmFlg: boolean = isValid(CMItemCode.CM_ENABLED);
		return (
			<div className={classes.root} ref={div => (this.rootDiv = div)}>
				{isMobile() && (
					<>
						<Grid
							container={true}
							justify="center"
							className={classes.accessBar}
							ref={(el: HTMLDivElement) =>
								el && Stickyfill.add(el)
							}
						>
							<Paper style={{ width: '100%' }}>
								<div className={classes.mobileTable}>
									<div className={classes.mobileCellItemName}>
										{i18n.t(
											'CurriculumAchieveCondition_0001'
										)}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{curriculumInfo.careerName}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18n.t(
											'CurriculumAchieveCondition_0002'
										)}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{curriculumInfo.credit}
									</div>
								</div>
							</Paper>
						</Grid>
					</>
				)}
				{!isMobile() && (
					<>
						<div className={classes.wrapDiv}>
							<Paper className={classes.topTable}>
								<Table>
									<TableBody>
										<TableRow>
											<TableCell
												className={
													classes.topCellItemName
												}
											>
												{i18n.t(
													'CurriculumAchieveCondition_0001'
												)}
											</TableCell>
											<TableCell
												className={
													classes.topCellItemValue
												}
											>
												{curriculumInfo.careerName}
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell
												className={
													classes.topCellItemName
												}
											>
												{i18n.t(
													'CurriculumAchieveCondition_0002'
												)}
											</TableCell>
											<TableCell
												className={
													classes.topCellItemValue
												}
											>
												{curriculumInfo.credit}
											</TableCell>
										</TableRow>
									</TableBody>
								</Table>
							</Paper>
						</div>
					</>
				)}
				{!isMobile() && (
					<>
						<div className={classes.wrapDiv}>
							<Typography
								variant="h6"
								color="inherit"
								className={classes.flex}
							>
								{i18n.t('CurriculumAchieveCondition_0003')}
							</Typography>
							<Paper>
								<Table>
									<TableHead>
										<TableRow>
											<TableCell
												className={classes.headerName1}
											>
												{i18n.t(
													'CurriculumAchieveCondition_0004'
												)}
											</TableCell>
											<TableCell
												className={classes.headerName2}
											>
												{cmFlg
													? i18n.t(
															'CurriculumAchieveCondition_0005'
													  )
													: i18n.t(
															'CurriculumAchieveCondition_0006'
													  )}
											</TableCell>
											<TableCell
												className={classes.headerName3}
											>
												{cmFlg
													? i18n.t(
															'CurriculumAchieveCondition_0007'
													  )
													: i18n.t(
															'CurriculumAchieveCondition_0008'
													  )}
											</TableCell>
											<TableCell
												className={classes.headerName4}
											>
												{cmFlg
													? i18n.t(
															'CurriculumAchieveCondition_0009'
													  )
													: i18n.t(
															'CurriculumAchieveCondition_0010'
													  )}
											</TableCell>
											<TableCell
												className={classes.headerName5}
											>
												{i18n.t(
													'CurriculumAchieveCondition_0011'
												)}
											</TableCell>
											<TableCell
												className={classes.headerName6}
											>
												{i18n.t(
													'CurriculumAchieveCondition_0018'
												)}
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{requiredCareers.map(
											(
												item: ISubCareerInfo,
												index: number
											) => {
												return (
													<TableRow key={index}>
														<TableCell>
															{
																item.managementCode
															}
														</TableCell>
														<TableCell>
															<span
																className={
																	classes.link
																}
																onClick={
																	this
																		.showCareerDetail
																}
																data-careerid={
																	item.careerId
																}
															>
																{
																	item.careerName
																}
															</span>
														</TableCell>
														<TableCell>
															{item.careerId}
														</TableCell>
														<TableCell>
															{item.careerType ===
																'eラーニング' ||
															item.careerType ===
																'集合研修' ||
															item.careerType ===
																'通信教育' ||
															item.careerType ===
																'資格' ||
															item.careerType ===
																'業務経験' ||
															item.careerType ===
																'スキル診断'
																? i18n.t(
																		item.careerType,
																		{
																			ns:
																				'force',
																		}
																  )
																: item.careerType}
														</TableCell>
														<TableCell>
															{item.credit}
														</TableCell>
														<TableCell>
															{item.studyOrder}
														</TableCell>
													</TableRow>
												);
											},
											this
										)}
									</TableBody>
								</Table>
							</Paper>
							<Grid container={true} justify={'flex-end'}>
								<Grid item={true}>
									<Button
										className={classes.button}
										variant="contained"
										color="default"
										onClick={this.pageTop}
									>
										{i18n.t(
											'CurriculumAchieveCondition_0012'
										)}
									</Button>
								</Grid>
							</Grid>
						</div>
					</>
				)}
				{isMobile() && (
					<>
						<Typography
							variant="h6"
							color="inherit"
							className={classes.mobileFlex}
						>
							{i18n.t('CurriculumAchieveCondition_0003')}
						</Typography>
						{requiredCareers.map(
							(item: ISubCareerInfo, index: number) => {
								return (
									<>
										{index !== 0 && (
											<div
												style={{
													maxHeight: '5px',
													minHeight: '5px',
												}}
											/>
										)}
										<Paper>
											<div
												className={classes.mobileTable}
											>
												<div
													className={
														classes.mobileCellItemName
													}
												>
													{i18n.t(
														'CurriculumAchieveCondition_0017'
													)}
												</div>
												<div
													className={
														classes.mobileCellItemValue
													}
												>
													{item.managementCode}
												</div>
												<div
													className={
														classes.mobileCellItemName
													}
												>
													{i18n.t(
														'CurriculumAchieveCondition_0006'
													)}
												</div>
												<div
													className={
														classes.mobileCellItemValue
													}
													onClick={
														this.showCareerDetail
													}
													data-careerid={
														item.careerId
													}
													style={{
														color: 'blue',
														cursor: 'pointer',
													}}
												>
													{item.careerName}
												</div>
												<div
													className={
														classes.mobileCellItemName
													}
												>
													{i18n.t(
														'CurriculumAchieveCondition_0008'
													)}
												</div>
												<div
													className={
														classes.mobileCellItemValue
													}
												>
													{item.careerId}
												</div>
												<div
													className={
														classes.mobileCellItemName
													}
												>
													{i18n.t(
														'CurriculumAchieveCondition_0010'
													)}
												</div>
												<div
													className={
														classes.mobileCellItemValue
													}
												>
													{item.careerType ===
														'eラーニング' ||
													item.careerType ===
														'集合研修' ||
													item.careerType ===
														'通信教育' ||
													item.careerType ===
														'資格' ||
													item.careerType ===
														'業務経験' ||
													item.careerType ===
														'スキル診断'
														? i18n.t(
																item.careerType,
																{
																	ns: 'force',
																}
														  )
														: item.careerType}
												</div>
												<div
													className={
														classes.mobileCellItemName
													}
												>
													{i18n.t(
														'CurriculumAchieveCondition_0011'
													)}
												</div>
												<div
													className={
														classes.mobileCellItemValue
													}
												>
													{item.credit}
												</div>
												<div
													className={
														classes.mobileCellItemName
													}
												>
													{i18n.t(
														'CurriculumAchieveCondition_0018'
													)}
												</div>
												<div
													className={
														classes.mobileCellItemValue
													}
												>
													{item.studyOrder}
												</div>
											</div>
										</Paper>
									</>
								);
							},
							this
						)}
						<Grid container={true} justify={'flex-end'}>
							<Grid item={true}>
								<Button
									className={classes.button}
									variant="contained"
									color="default"
									onClick={this.pageTop}
								>
									{i18n.t('CurriculumAchieveCondition_0012')}
								</Button>
							</Grid>
						</Grid>
					</>
				)}
				{!isMobile() && (
					<>
						<div className={classes.wrapDiv}>
							<Typography
								variant="h6"
								color="inherit"
								className={classes.flex}
							>
								{i18n.t('CurriculumAchieveCondition_0013')}
							</Typography>
							<Paper>
								<Table>
									<TableHead>
										<TableRow>
											<TableCell
												className={classes.headerName1}
											>
												{i18n.t(
													'CurriculumAchieveCondition_0004'
												)}
											</TableCell>
											<TableCell
												className={classes.headerName2}
											>
												{cmFlg
													? i18n.t(
															'CurriculumAchieveCondition_0005'
													  )
													: i18n.t(
															'CurriculumAchieveCondition_0006'
													  )}
											</TableCell>
											<TableCell
												className={classes.headerName3}
											>
												{cmFlg
													? i18n.t(
															'CurriculumAchieveCondition_0007'
													  )
													: i18n.t(
															'CurriculumAchieveCondition_0008'
													  )}
											</TableCell>
											<TableCell
												className={classes.headerName4}
											>
												{cmFlg
													? i18n.t(
															'CurriculumAchieveCondition_0009'
													  )
													: i18n.t(
															'CurriculumAchieveCondition_0010'
													  )}
											</TableCell>
											<TableCell
												className={classes.headerName5}
											>
												{i18n.t(
													'CurriculumAchieveCondition_0011'
												)}
											</TableCell>
											<TableCell
												className={classes.headerName6}
											>
												{i18n.t(
													'CurriculumAchieveCondition_0018'
												)}
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{optionalCareers.map(
											(
												item: ISubCareerInfo,
												index: number
											) => {
												return (
													<TableRow key={index}>
														<TableCell>
															{
																item.managementCode
															}
														</TableCell>
														<TableCell>
															<span
																className={
																	classes.link
																}
																onClick={
																	this
																		.showCareerDetail
																}
																data-careerid={
																	item.careerId
																}
															>
																{
																	item.careerName
																}
															</span>
														</TableCell>
														<TableCell>
															{item.careerId}
														</TableCell>
														<TableCell>
															{item.careerType ===
																'eラーニング' ||
															item.careerType ===
																'集合研修' ||
															item.careerType ===
																'通信教育' ||
															item.careerType ===
																'資格' ||
															item.careerType ===
																'業務経験' ||
															item.careerType ===
																'スキル診断'
																? i18n.t(
																		item.careerType,
																		{
																			ns:
																				'force',
																		}
																  )
																: item.careerType}
														</TableCell>
														<TableCell>
															{item.credit}
														</TableCell>
														<TableCell>
															{item.studyOrder}
														</TableCell>
													</TableRow>
												);
											}
										)}
									</TableBody>
								</Table>
							</Paper>
							<Grid container={true} justify={'flex-end'}>
								<Grid item={true}>
									<Button
										className={classes.button}
										variant="contained"
										color="default"
										onClick={this.pageTop}
									>
										{i18n.t(
											'CurriculumAchieveCondition_0012'
										)}
									</Button>
								</Grid>
							</Grid>
						</div>
					</>
				)}
				{isMobile() && (
					<>
						<Typography
							variant="h6"
							color="inherit"
							className={classes.mobileFlex}
						>
							{i18n.t('CurriculumAchieveCondition_0013')}
						</Typography>
						{optionalCareers.map(
							(item: ISubCareerInfo, index: number) => {
								return (
									<>
										{index !== 0 && (
											<div
												style={{
													maxHeight: '5px',
													minHeight: '5px',
												}}
											/>
										)}
										<Paper>
											<div
												className={classes.mobileTable}
											>
												<div
													className={
														classes.mobileCellItemName
													}
												>
													{i18n.t(
														'CurriculumAchieveCondition_0017'
													)}
												</div>
												<div
													className={
														classes.mobileCellItemValue
													}
												>
													{item.managementCode}
												</div>
												<div
													className={
														classes.mobileCellItemName
													}
												>
													{i18n.t(
														'CurriculumAchieveCondition_0006'
													)}
												</div>
												<div
													className={
														classes.mobileCellItemValue
													}
													onClick={
														this.showCareerDetail
													}
													data-careerid={
														item.careerId
													}
													style={{
														color: 'blue',
														cursor: 'pointer',
													}}
												>
													{item.careerName}
												</div>
												<div
													className={
														classes.mobileCellItemName
													}
												>
													{i18n.t(
														'CurriculumAchieveCondition_0008'
													)}
												</div>
												<div
													className={
														classes.mobileCellItemValue
													}
												>
													{item.careerId}
												</div>
												<div
													className={
														classes.mobileCellItemName
													}
												>
													{i18n.t(
														'CurriculumAchieveCondition_0010'
													)}
												</div>
												<div
													className={
														classes.mobileCellItemValue
													}
												>
													{item.careerType ===
														'eラーニング' ||
													item.careerType ===
														'集合研修' ||
													item.careerType ===
														'通信教育' ||
													item.careerType ===
														'資格' ||
													item.careerType ===
														'業務経験' ||
													item.careerType ===
														'スキル診断'
														? i18n.t(
																item.careerType,
																{
																	ns: 'force',
																}
														  )
														: item.careerType}
												</div>
												<div
													className={
														classes.mobileCellItemName
													}
												>
													{i18n.t(
														'CurriculumAchieveCondition_0011'
													)}
												</div>
												<div
													className={
														classes.mobileCellItemValue
													}
												>
													{item.credit}
												</div>
												<div
													className={
														classes.mobileCellItemName
													}
												>
													{i18n.t(
														'CurriculumAchieveCondition_0018'
													)}
												</div>
												<div
													className={
														classes.mobileCellItemValue
													}
												>
													{item.studyOrder}
												</div>
											</div>
										</Paper>
									</>
								);
							}
						)}
						<Grid container={true} justify={'flex-end'}>
							<Grid item={true}>
								<Button
									className={classes.button}
									variant="contained"
									color="default"
									onClick={this.pageTop}
								>
									{i18n.t('CurriculumAchieveCondition_0012')}
								</Button>
							</Grid>
						</Grid>
					</>
				)}
				<div className={classes.wrapDiv}>
					<Grid container={true} justify={'center'}>
						<Grid item={true}>
							<Button
								className={classes.button}
								variant="contained"
								color="default"
								onClick={this.showCurriculumDetail}
							>
								{i18n.t('CurriculumAchieveCondition_0014')}
							</Button>
						</Grid>
					</Grid>
				</div>
				<Dialog
					fullScreen={false}
					TransitionComponent={UpwardTransition}
					open={this.state.openCareerDetailDialog}
					onClose={this.handlecloseDetailDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: this.props.classes.careerDialog,
						scrollPaper: this.props.classes.scrollPaper,
					}}
				>
					<AppBar className={this.props.classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handlecloseDetailDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18n.t('CurriculumAchieveCondition_0015')}
							</Typography>
						</Toolbar>
					</AppBar>
					<CareerDetail careerID={this.state.careerID} />
				</Dialog>
				<Dialog
					fullScreen={false}
					TransitionComponent={UpwardTransition}
					open={this.state.openSkillDetailDialog}
					onClose={this.handlecloseDetailDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: this.props.classes.careerDialog,
					}}
				>
					<AppBar className={this.props.classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handlecloseDetailDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18n.t('CurriculumAchieveCondition_0019')}
							</Typography>
						</Toolbar>
					</AppBar>
					<SkillDetail skillId={this.state.careerID} />
				</Dialog>
			</div>
		);
	}

	/**
	 * ページトップ移動ハンドラ
	 */
	protected pageTop = () => {
		if (this.rootDiv) {
			this.pageTopCore(this.rootDiv);
		}
	};

	/**
	 * ページトップ移動実行
	 */
	protected pageTopCore = (elem: HTMLElement) => {
		elem.scrollTop = 0;
		if (elem.parentElement) {
			this.pageTopCore(elem.parentElement);
		}
	};

	/**
	 * 研修情報詳細表示
	 * @param e
	 */
	protected showCareerDetail(e: React.MouseEvent<HTMLElement>) {
		const careerId = e.currentTarget.getAttribute('data-careerid');
		if (careerId) {
			if (this.props.curriculumId) {
				if (careerId.startsWith('CK')) {
					this.setState({
						careerID: careerId,
						openSkillDetailDialog: true,
					});
				} else {
					this.setState({
						careerID: careerId,
						openCareerDetailDialog: true,
					});
				}
			} else {
				if (careerId.startsWith('CK')) {
					let to = Routes.getPath(Screens.PERSONAL_SKILL_DETAIL);
					to = to.replace(/\/:skill_id/, `/${careerId}`);
					this.props.pushHistory(to);
				} else {
					let to = Routes.getPath(Screens.PERSONAL_CAREER_DETAIL);
					to = to.replace(/\/:career_id/, `/${careerId}`);
					this.props.pushHistory(to);
				}
			}
		}
	}

	protected handlecloseDetailDialog = () => {
		this.setState({ careerID: '', openCareerDetailDialog: false });
		this.setState({ careerID: '', openSkillDetailDialog: false });
	};

	protected showCurriculumDetail(e: React.MouseEvent<HTMLElement>) {
		const { careerId } = this.props.curriculumInfo;
		if (this.props.curriculumId) {
			this.props.setCurriculumDetailDialog(false);
		} else {
			if (careerId) {
				let to = Routes.getPath(Screens.PERSONAL_CURRICULUM_DETAIL);
				to = to.replace(/\/:curriculum_id/, `/${careerId}`);
				this.props.pushHistory(to);
			}
		}
	}
}

const mapStateToProps = (state: IRootState) => ({
	cmFlg: state.login.showCMOption,
	curriculumInfo: state.search.curriculumAchieveCondition.curriculumInfo,
	optionalCareers: state.search.curriculumAchieveCondition.optionalCareers,
	requiredCareers: state.search.curriculumAchieveCondition.requiredCareers,
	token: state.session.token,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchCurriculumAchieveCondition: (curriculumId: string, token: string) => {
		const s = ScenarioFactory.createFetchCurriculumAchieveCondition(
			dispatch,
			token
		);
		s.run(curriculumId);
	},
	pushHistory: (path: string) => dispatch(push(path)),
	resetCurriculumAchieveCondition: () =>
		dispatch(
			setCurriculumAchieveCondition({
				curriculumInfo: {},
				optionalCareers: [],
				requiredCareers: [],
			})
		),
	setCurriculumDetailDialog: (OpenCurriculumDetailDialog: boolean) =>
		dispatch(setCurriculumDetailDialog({ OpenCurriculumDetailDialog })),
});

export interface ICurriculumAchieveConditionProps {
	curriculumId: string;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	RouteComponentProps<IRouteParams, StaticContext, IRouteState> &
	ICurriculumAchieveConditionProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(CurriculumAchieveCondition);

const Styled = withStyles(styles)(Connected);
const Export: React.ComponentType<ICurriculumAchieveConditionProps> = Styled;

export default Export;



// WEBPACK FOOTER //
// ./src/containers/CurriculumAchieveCondition.tsx